import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import Spinner from '../../../reusable-components/Spinner';
import PropTypes from 'prop-types';

export default class NotFoundComponent extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount() {
    const { setVignetNumber, location, history } = this.props;
    let url = location.pathname;
    // strip the url of /
    let str = url.replace(/[/]/g, '');

    // test if valid vignet number
    if( /^([A-Z]{2}[0-9]{5})?$/i.test(str) ) {
      setVignetNumber(str);
    }
    history.push('/activate');
  }

  render() {
    return (
      <div className="success-message text-center">
        <div className="icon">
          <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style={{fontSize: "15px"}}></span>
          <span className="sr-only">Loading...</span>
        </div>
        <span>even geduld aub, omleiden...</span>
      </div>
    );
  }
}

